<template>
  <div class="h100pc">
       <img
        class="back"
        @click="goHome"
        v-lazy="require('./../../../assets/img/back2.png')"
      />
    <div class="hd bggray">
      <span class="hd_span f16"> 我的收藏</span>
      <div class="input" @click="openValue">
        <div class="f14 select" style="color: #42686e">
          <span class="select_txt">{{ selected }}</span>
          <img src="./../../../assets/img/test/down-arrow-1.png" alt="" />
        </div>
        <div class="list" v-show="show">
          <div class="flex" @click="getFatherValue">
            <span
              :class="item.text == selected ? 'li active' : 'li'"
              :key="item.value"
              v-for="item in categoricals"
              :data-val="item.value"
              :data-txt="item.text"
              >{{ item.text }}</span
            >
          </div>
        </div>
      </div>
    </div>

    <div class="testlist">
      <div class="overlay" v-if="show" @click="openValue"></div>
      <NoPic style="margin-top: 50%" v-if="!testLen"></NoPic>
      <van-pull-refresh v-model="isDownLoading" @refresh="onDownRefresh">
        <van-list
          v-model="isUpLoading"
          :finished="upFinished"
          :immediate-check="false"
          :offset="5"
          finished-text="我是有底线的"
          @load="onLoadList"
        >
          <div class="cardBox">
            <testList :tests="nTests"></testList>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import TestList from "@/components/TestList";
import NoPic from "@/components/NoPic";
import { getMycollection, getAllCat } from "@/http/api";
import { mapGetters } from "vuex";
export default {
  name: "collection",
  data() {
    return {
      value: "",
      show: false,
      selected: "全部分类",
      categoricals: [
        {
          value: "",
          text: "全部分类",
        },
      ],
      nTests: [],
      testLen: 0,

      // 分页
      total: 0,
      pageSize: 5, // 每页条数
      pageIndex: 1, // 页码
      isDownLoading: false, // 下拉刷新
      isUpLoading: false, // 上拉加载
      upFinished: false, // 上拉加载完毕
      offset: 100, // 滚动条与底部距离小于 offset 时触发load事件
    };
  },
  watch: {
    categoricals(val) {
      this.categoricals = val;
    },
  },
  methods: {},
  computed: {
    // ...mapGetters(['user_id'])
  },
  created() {
    getAllCat().then((res) => {
      this.categoricals = this.categoricals.concat(
        res.data.objects.map((u, i) => {
          return {
            text: u.name,
            value: u.id,
          };
        })
      );
      console.log(this.categoricals);
      this.selected = this.categoricals[0].text;
      //   this.couponSelected = this.couponList[0].id;
      this.getroadList();
    });
  },
  methods: {
    goHome() {
      this.$router.push("/my/center");
    },
    // 模拟select组件
    openValue() {
      this.show = !this.show;
      console.log(this.categoricals);
    },
    getValue(index, item) {
      console.log("获取", item);
      let params = {
        page: this.pageIndex,
        page_size: this.pageSize,
      };
      if (item) {
        this.value = item.value;
        this.selected = item.text;
        params.evaluation_type = this.value;
      }
      console.log("获取分类", params);
      getMycollection(params).then((res) => {
        console.log("我的收藏", res, this.selected);
        // if(this.selected==='全部分类'){
        //  this.nTests = this.nTests.concat(res.data.objects)
        // }
        // else{
        this.nTests = res.data.objects;
        // }
      });
    },
    getFatherValue(e) {
      if (e.target.localName == "span") {
        let item = e.target.dataset;
        console.log(item);
        // console.dir(id);
        let params = {
          page: this.pageIndex,
          page_size: this.pageSize,
        };
        if (item) {
          this.value = item.val;
          this.selected = item.txt;
          params.evaluation_type = item.val;
        }
        console.log("获取分类", params);
        getMycollection(params).then((res) => {
          console.log("我的收藏", res, this.selected);
          // if(this.selected==='全部分类'){
          //  this.nTests = this.nTests.concat(res.data.objects)
          // }
          // else{
          this.nTests = res.data.objects;
          // }
        });
      }
    },
    getroadList(item) {
      let params = {
        page: this.pageIndex,
        page_size: this.pageSize,
      };
      if (item) {
        this.value = item.value;
        this.selected = item.text;
        params.evaluation_type = this.value;
      }
      getMycollection(params)
        .then((res) => {
          console.log("请求", res);
          this.total = res.data.count;
          if (res.data.objects) {
            this.nTests = this.nTests.concat(res.data.objects);
            this.testLen = this.nTests.length;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.isDownLoading = false;
          this.isUpLoading = false;
        });
    },
    // 下拉刷新
    onDownRefresh() {
      this.nTests = [];
      this.pageIndex = 1;
      this.upFinished = false; // 不写这句会导致你上拉到底过后在下拉刷新将不能触发下拉加载事件
      this.getroadList(); // 加载数据
    },
    // 上拉加载请求方法
    onLoadList() {
      if (this.total > this.pageIndex * this.pageSize) {
        this.pageIndex++;
        this.getroadList();
      } else {
        this.upFinished = true;
      }
    },
  },
  components: {
    TestList,
    NoPic,
  },
};
</script>

<style lang="less" scoped>
.back {
  width: 22px;
  height: 23px;
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  left: 5px;
  top: 5px;
}
html,
body {
  height: 100%;
}

.hd {
  height: 40px;
  // line-height: 40px;
  display: flex;
  justify-content: space-between;

  .hd_span {
    margin-left: 40px;
    line-height: 40px;
  }

  .input {
    // display: inline-block;
    // width: 30%;
    // float: right;
    // position: relative;
    // font-size: small;
    // text-align: center;
  }

  .select {
    height: 100%;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 30px;

    .select_txt {
      display: inline-block;
      height: 14px;
      margin-right: 5px;
    }

    img {
      width: 7px;
      height: 7px;
    }
  }

  .list {
    position: absolute;
    top: 40px;
    left: 0;
    z-index: 2;
    // border-radius: 0 0 10px 10px;
    background: #f9f9f9;
    width: 100vw;
    padding: 32px 5px;
    padding-bottom: 10px;
    .flex {
      display: flex;
      flex-wrap: wrap;

      .li {
        display: block;
        text-align: center;
        width: 65px;
        height: 28px;
        background: #fff;
        border-radius: 2px;
        border: 2px solid #000000;
        font-size: 13px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #4a4a4a;
        line-height: 24px;
        margin-right: 12px;
        margin-left: 13px;
        margin-bottom: 15px;
      }

      .active {
        width: 65px;
        height: 28px;
        background: #42686e;
        border-radius: 2px;
        color: #fff;
      }
    }

    li {
      font-size: 16px;
      line-height: 34px;
      color: #d6d6d6;
      text-align: center;

      hr {
        margin: 0;
      }
    }

    li:last-child {
      hr {
        display: none;
      }
    }
  }
}

.testlist {
  height: 92%;
  // min-height: 15rem;
  width: 100%;
  // overflow: scroll;
  position: relative;
  padding-top: 20px;

  .overlay {
    position: fixed;
    top: 40px;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 1;
  }
}

.cardBox {
  padding: 0 22px;
}
</style>
